import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import "../../views/common/helloava.css";
import "../../views/common/animate.css";
import styled from "styled-components";
import AthHeader from "../components/header/AthHeader";
import * as aaUtil from "../utils/aaUtils";

import "./AthLayout.css";

class AthLayout extends Component {
  constructor() {
    super();

    this.state = {
      showBanner: false
    };
  }
  orderStyle = {
    order: 2
  };

  componentDidMount() {
    aaUtil.mountAdobeScript();
  }

  render() {
    const urlPath = this.props.match.path;
    let EmptyDiv = styled.div`
      order: 2;
      height: 3.5em;
    `;
    return (
      <div className="intro-fixed ath-intro-fixed">
        <AthHeader
          onboarding={true}
          location={urlPath}
          history={this.props.history}
        />

        {/*<div
            id="content-container"
            className="ath-container__body intro-fixed"
            style={this.orderStyle}
          >*/}
        {this.props.children}
        {/*</div>*/}
        {/*showFooter && <Footer location={ urlPath }/> */}
      </div>
      
    );
  }
}

function mapStateToProps(state) {
  const { helloava } = state;
  const { isAuthenticated } = helloava.auth;
  return { isAuthenticated };
}

export default withRouter(connect(mapStateToProps)(AthLayout));



// WEBPACK FOOTER //
// ./src/ath/layout/AthLayout.js